import React, { useCallback, useState, } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles, } from '@material-ui/styles'
import { lighten, } from '@material-ui/core/styles/colorManipulator'
import classNames from 'classnames'
import ClassNameType from '@shapr/react-shared/types/ClassName'
import AsyncType, { AsyncState, } from '@shapr/react-shared/types/Async'

import Typography from '@material-ui/core/Typography'
import Criteria from './Criteria'
import CriteriaType from './types/Criteria'

const Search = props => {
  const {
    className,
    onDownload,
    onReset,
    criterias,
    resultNumber,
    getSearchResultState,
  } = props
  const classes = useStyles()

  const handleSubmit = useCallback(
    e => {
      e.preventDefault()
      onDownload()
    },
    [onDownload,],
  )

  const [resetState, setResetState,] = useState(0)
  const handleResetClick = useCallback(
    e => {
      if (resetState === 0) setResetState(1)
      else {
        setResetState(0)
        onReset()
      }
    },
    [resetState,],
  )
  const handleResetBlur = useCallback(e => {
    e.preventDefault()
  }, [])

  const atLeastOneCriteriaToSearch = criterias.reduce(
    (acc, criteria) =>
      acc ||
      (criteria.isWithMultipleSelection
        ? criteria.selectedValues.length > 0
        : criteria.inputValue.length > 0),
    false,
  )

  return (
    <form
      onSubmit={handleSubmit}
      className={classNames(classes.root, className)}
    >
      {criterias.map(criteria => (
        <Criteria criteria={criteria} key={criteria.label} />
      ))}
      {getSearchResultState === AsyncState.pending && (
        <CircularProgress
          size={36}
          className={classes.getSearchResultProgress}
        />
      )}
      {getSearchResultState !== AsyncState.pending &&
        typeof resultNumber !== 'undefined' && (
          <Typography variant="body1">
            {`You excel file have ${resultNumber} result(s)`}
          </Typography>
        )}
      <Button
        type="submit"
        disabled={typeof resultNumber === 'undefined' || resultNumber === 0}
      >
        Download
      </Button>
      {resetState === 0 ? (
        <Button
          onClick={handleResetClick}
          disabled={!atLeastOneCriteriaToSearch}
        >
          Clear Form
        </Button>
      ) : (
        <Button
          onClick={handleResetClick}
          onBlur={handleResetBlur}
          disabled={!atLeastOneCriteriaToSearch}
          className={classes.resetButtonConfirmation}
        >
          Are you sure ?
        </Button>
      )}
    </form>
  )
}

const useStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  getSearchResultProgress: {
    alignSelf: 'center',
  },
  resetButtonConfirmation: {
    color: theme.palette.common.white,
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: lighten(theme.palette.error.main, 0.2),
    },
  },
}))

Search.propTypes = {
  className: ClassNameType.isRequired,
  onDownload: PropTypes.func.isRequired,
  onReset: PropTypes.func.isRequired,
  criterias: PropTypes.arrayOf(CriteriaType.isRequired).isRequired,
  resultNumber: PropTypes.number,
  getSearchResultState: AsyncType.isRequired,
}

export default React.memo(Search)
